import React, { useEffect, useState } from 'react';

export const PROGRESS_STRIP_COPY = {
  eyebrow: 'Your progress',
  reassurance: 'We get back to you within a week. No ghosting, ever.',
  markers: [
    { id: 1, label: 'Details' },
    { id: 2, label: 'Interview' },
    { id: 3, label: 'Decision' }
  ]
};

/**
 * Compact horizontal hiring progress (replaces vertical timeline).
 *
 * @param {{
 *   activeStep?: number;
 *   pulseToken?: number;
 *   className?: string;
 * }} props
 * pulseToken: increment from parent when candidate sends a chat message (triggers active-dot pulse).
 */
export default function WhatHappensNext({ activeStep = 1, pulseToken = 0, className = '' }) {
  const { eyebrow, reassurance, markers } = PROGRESS_STRIP_COPY;
  const [pulsing, setPulsing] = useState(false);

  useEffect(() => {
    if (!pulseToken) return undefined;
    setPulsing(true);
    const id = window.setTimeout(() => setPulsing(false), 800);
    return () => window.clearTimeout(id);
  }, [pulseToken]);

  return (
    <section
      className={`cep-progress ${className}`.trim()}
      aria-label="Your progress in the hiring process"
    >
      <p className="cep-eyebrow cep-progress__eyebrow">
        <span className="cep-eyebrow__rule" aria-hidden="true" />
        {eyebrow}
      </p>

      <div className="cep-progress__strip">
        <div className="cep-progress__line" aria-hidden="true" />
        <ol className="cep-progress__markers">
          {markers.map((marker) => {
            const isActive = marker.id === activeStep;
            return (
              <li key={marker.id} className="cep-progress__marker">
                <span
                  className={`cep-progress__dot${isActive ? ' cep-progress__dot--active' : ' cep-progress__dot--upcoming'}${isActive && pulsing ? ' cep-progress__dot--pulse' : ''}`}
                  aria-hidden="true"
                />
                <span
                  className={`cep-progress__label${isActive ? ' cep-progress__label--active' : ''}`}
                >
                  {marker.label}
                </span>
              </li>
            );
          })}
        </ol>
      </div>

      <p className="cep-progress__reassurance">{reassurance}</p>
    </section>
  );
}
